// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3Itzl","obliqueLineWrap":"membershipbadge_obliqueLineWrap__Owvv0","obliqueLine":"membershipbadge_obliqueLine__1KM_w"};